import { ElemInstalacionDetalleModel } from "./elem-instalacion-detalle.model";
import { ElemInstalacionEstadoModel } from "./elem-instalacion-estado.model";
import { ElemInstalacionNuevaInstalacion } from "./elem-instalacion-nueva-instalacion.model";

export class ElemInstalacionModel {
  detalle: ElemInstalacionDetalleModel[] = [];
  empresa: number = 0;
  estado: ElemInstalacionEstadoModel = new ElemInstalacionEstadoModel();
  fechaBaja: string = '';
  fechaCreacion: string = '';
  fechaModificacion: string = '';
  guid: string = '';
  id: number = 0;
  idElemento: number = 0;
  idEstado: number = 1; /* SinInstalar = 1, EnProgreso = 2, Finalizada = 3 */
  instalaciones: ElemInstalacionNuevaInstalacion[] = [];
  observaciones: string = '';
  requiereInstalacionCerradura: Boolean = false;
  requiereInstalacionIdentificador: Boolean = false;
  requiereInstalacionTag: Boolean = false;
  requiereInstalacionVolumetrico: Boolean = false;
  fechaOperacion: string = '';
  fechaUltimaConexion: string | null = null;
  idCerradura: number | null = null;
  nsMovisat: string | null = null;
  nsFabricante: string | null = null;
  imei: string | null = null;
  nombreElemento: string = '';
  calle: string = '';
  provincia: string = '';
  municipio: string = '';
  idTipo: number;
  nombreTipo: string = '';
  idUsuario: number;
  idEstadoInstalacion: number;
  estadoInstalacion: string = '';
  incidencias: boolean = false;
  nombreCortoEmpleado: string = '';
}
